export var animation = {
  transitionDuration: '250ms'
};
export default animation;